export enum PageEnum {
  DASHBOARD = "dashboard",
  PERSONAL_DETAILS = "personal_details",
  SETTINGS = "settings",
  HELP_CENTER = "help_center",
  FEEDBACK = "feedback",
  LEGAL = "legal",
  LOG_OUT = "log_out",
  DELETE_ACCOUNT = "delete_account",
  REPORT = "report",
  MARKETING_PREFERENCES = "marketing_preferences",
}

export enum MainCategoryEnum {
  DASHBOARD = "dashboard",
  MENU = "menu",
  MY_ACCOUNT = "my_account",
  REPORT = "report",
  CREDIT_REPORT = "credit_report",
  REPORT_SEARCH = "report_search",
  SETTINGS = "settings",
  EMAIL = "email",
  SCORE_GLANCE = "score_glance",
  SCORE_BUILDERS = "score_builders",
  DEALS = "deals"
}

export enum LoginJourneyEnum {
  STANDARD = "standard",
  CRM = "crm",
}

export enum ScreenEnum {
  DASHBOARD_HOME = "dashboard_home",
  LEGAL = "legal_screen",
  PREFERENCES = "preferences_updated",
  UPDATED_ERROR = "updated_error",
  PREFERENCES_BANNER = "preferences_banner",
  SETTINGS = "settings",
  ACCOUNT_DELETED = "account_deleted",
  CREDIT_REPORT = "credit_report",
  CREDIT_REPORT_HOME = "credit_report_home",
  UPCOMING_SCORE = "upcoming_score",
  TAKE_ACTION = "take_action",
  LETS_IMPROVE = "lets_improve",
  DOING_GREAT = "doing_great",
  REPORT_BANNER = "report_banner",
  REPORT_UPCOMING_BANNER = "report_upcoming_banner",
  REPORT_UPCOMING_BLURRED_BANNER = "report_upcoming_blurred_banner",
  REPORTS_MAIN = "report_main",
  DASHBOARD = "dashboard",
  MY_ACCOUNT_HOME = "my_account_home",
  DASHBOARD_GET_THE_APP = "dashboard_get_the_app",
  DASHBOARD_BANNER = "dashboard_banner",
  SCORE_BUILDERS = "score_builders",
  DEALS_SCREEN = "deals_screen"
}

export enum AnalyticsActionEnum {
  CLICK = "click",
  SCROLL = "scroll",
  REPORT_EXPANATION = "report_explanation",
  VIEW_ALL = "view_all",
  TAKE_ACTION = "take_action",
  LETS_IMPROVE = "lets_improve",
  DOING_GREAT = "doing_great",
  UPCOMING_CHANGES = "upcoming_changes",
  SCORE_BUILDER = "score_builders",
  CLOSED = "closed",
  OPENED = "opened",
}

export enum ScoreBuilderActionEnum {
  CLICK = "click",
  SCROLL = "scroll",
}

export enum CallerEnums {
  CC = 0,
  PL = 1,
  CCF = 2,
  SL = 3
}
